import React, {FC} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientAtom} from '../../../editors/expressions/expressionAtomModel';
import {getLabelForInferredType} from '../../../editors/expressions/expressionLabels';
import {RuleMultilineParameterCard} from '../ruleMultilineParameterCard';
import {AtomIcon} from './atomIcon';

/*
 * Types.
 */

export interface FunctionStartAtomCardProps {
  atom: ClientAtom;
  isDisabled?: boolean;
  onCancel?: Handler;
}

/*
 * Component.
 */

export const FunctionStartAtomCard: FC<FunctionStartAtomCardProps> = ({atom, onCancel}) => (
  <RuleMultilineParameterCard
    errorMessage={atom.errorMessage}
    icon={<AtomIcon atom={atom} />}
    title={getLabelForInferredType(atom.inferredType)}
    onCancel={onCancel}
  />
);
